// __webpack_public_path__ = publicPath;

import babelpolyfill from 'babel-polyfill'
import $ from 'jquery'
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import storejs from 'storejs'
import App from './App'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import * as actions from './vuex/actions'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
import 'assets/css/api.css'
import 'assets/css/icon/iconfont.css'
import 'assets/css/reset.css'
import 'font-awesome/css/font-awesome.min.css'
import { siteUrl, getServerCity } from './api/api.js';
import { LHCXPARTNER_ID, QQ_MAP_KEY, shouldRedirectToLongzhu, LONGZHU_REDIRECT_CONFIG } from "./common/js/constant.js";
/*import vueEventCalendar from 'vue-event-calendar'
 Vue.use(vueEventCalendar, {local: 'en'}) //可以设置语言，支持中文和英文*/
import preview from 'vue-photo-preview'
Vue.use(preview)
import moment from 'moment'

//import Mock from './mock'
//Mock.bootstrap();
Vue.use(MintUI);
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.prototype.moment = moment;
Vue.prototype.isWeixin = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}
Vue.prototype.isAliPAY = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/AlipayClient/i) == 'alipayclient') {
        return true;
    } else {
        return false;
    }
}

//判断有没有这个属性

Vue.prototype.hasPrototype = function (object, name) {
    return !!object.hasOwnProperty(name) && (name in object);
}
/*设置cookie*/
Vue.prototype.setCookie = function (name, val, timeVal) {
    let Days = (timeVal != undefined) && timeVal || 30,//设置cookie的存放天数 默认为30天
        nowTime = new Date();
    nowTime.setTime(nowTime.getTime() + Days * 3600 * 1000);
    document.cookie = name + "=" + encodeURIComponent(val) + ";expires=" + nowTime.toGMTString();
}
Vue.prototype.removeAllSpace = function (val) {
    return val.replace(/\s+/g, "");
    ;
}
/*获取cookie*/
Vue.prototype.getCookie = function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return decodeURIComponent(arr[2]);
    else
        return null;
}

/*删除cookie 设置cookie的过期时间*/
Vue.prototype.delCookie = function (name) {
    let nowTime = new Date(), val;
    nowTime.setTime(nowTime.getTime() - 1);
    val = this.getCookie(name);
    if (val != null) {
        document.cookie = name + "=" + val + ";expires=" + nowTime.toGMTString();
    }
}
NProgress.configure({ showSpinner: false });
const router = new VueRouter({
    //mode: 'history',
    routes
})
function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
}

// 默认城市配置
const DEFAULT_CITY_OPTION = { name: "无锡", id: "320200" }

Vue.prototype.getLocation = async function () {
    _hmt.push(['_trackEvent', 'index', 'getLocation', '获取位置'])
    var cities = []
    
    try {
        await getServerCity().then(data => {
            cities = data.data.data
        })
        await getCity(cities)
    } catch (error) {
        console.warn('getLocation 异常，使用默认城市:', error);
        // 确保即使在异常情况下也设置默认城市
        localStorage.setItem('cityOption', JSON.stringify(DEFAULT_CITY_OPTION))
    }
}

async function getCity(cities) {
    
    const promiseLocation = new Promise(function (resolve, reject) {
        // 设置超时处理，确保 Promise 一定会结束
        const timeout = setTimeout(() => {
            reject(DEFAULT_CITY_OPTION)
        }, 10000) // 10秒超时
        
        try {
            var geolocation = new qq.maps.Geolocation(QQ_MAP_KEY, "myapp");
            var cityOption = null
            
            geolocation.getLocation(function(result) {
                clearTimeout(timeout)
                if (result && typeof result.city !== 'undefined') {
                    // 定位到的城市
                    var locationCity = result.city
                    for (const city of cities) {
                        // 判断城市是否可提供服务
                        if (locationCity && locationCity.indexOf(city.name) != -1) {
                            cityOption = { name: city.name, id: city.code }
                            break
                        }
                    }
                    // 如果定位成功但城市不在服务范围内，使用默认城市
                    resolve(cityOption || DEFAULT_CITY_OPTION);
                } else {
                    reject(DEFAULT_CITY_OPTION)
                }
            }, function(error) {
                // 定位失败回调
                clearTimeout(timeout)
                reject(DEFAULT_CITY_OPTION)
            })
        } catch (error) {
            clearTimeout(timeout)
            reject(DEFAULT_CITY_OPTION)
        }
    })
    
    // 确保无论成功还是失败都会设置 cityOption
    await promiseLocation.then(cityOption => {
        console.log('定位成功:', cityOption);
        localStorage.setItem('cityOption', JSON.stringify(cityOption))
    }).catch(cityOption => {
        console.log('定位失败，使用默认城市:', cityOption);
        localStorage.setItem('cityOption', JSON.stringify(cityOption))
    })
}

const history = window.sessionStorage;
history.clear()
history.setItem("tabCity", 0);
let historyCount = history.getItem('count') * 1 || 0;
history.setItem('/', 0);
router.beforeEach((to, from, next) => {
    // 龙珠保单验证重定向逻辑
    const packageParam = getUrlParam('package');
    const partnerIdParam = getUrlParam('partner_id');
    
    if (shouldRedirectToLongzhu(packageParam, partnerIdParam) && to.path === '/service_types') {
        // 避免无限重定向：如果来源是 longzhu_verify，允许正常访问
        if (from.path !== '/longzhu_verify') {
            // 保留所有原始查询参数，包括 selected_services
            // 首先从 hash 之前的 URL 参数中获取所有参数
            const query = {};
            const search = window.location.search || '';
            if (search) {
                const queryString = search.charAt(0) === '?' ? search.substring(1) : search;
                if (queryString) {
                    queryString.split('&').forEach(segment => {
                        if (!segment) return;
                        const [rawKey, rawValue = ''] = segment.split('=');
                        if (rawKey) {
                            try {
                                const key = decodeURIComponent(rawKey);
                                const value = decodeURIComponent(rawValue.replace(/\+/g, ' '));
                                query[key] = value;
                            } catch (error) {
                                query[rawKey] = rawValue;
                            }
                        }
                    });
                }
            }
            // 然后将 hash 部分的查询参数合并进来（优先级更高）
            Object.assign(query, to.query);
            // 覆盖 selected_services 为配置的值
            query.selected_services = LONGZHU_REDIRECT_CONFIG.SELECTED_SERVICES;
            next({ path: '/longzhu_verify', query: query });
            return;
        }
    }
    
    let partner_id = getUrlParam('partner_id');
    let pathTo = to.path;
    if (to.path.includes('/third-login') || to.path.includes('/third-right') || to.path.includes('/third-activity-detail')) {
        document.title = '卡拉丁 汽车服务'
        if (to.path.includes('/third-activity-detail')) {
            next();
            return;
        }
    }
    if (to.path.indexOf('/choose_parts/') >= 0) {
        next(pathTo.split('/choose_parts/')[0]);
    } else {
        const toIndex = history.getItem(to.path);
        const fromIndex = history.getItem(from.path);
        if (toIndex) {
            if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
                store.commit(actions.UPDATE_DIRECTION, { direction: 'forward' })
            } else {
                store.commit(actions.UPDATE_DIRECTION, { direction: 'reverse' })
            }
        } else {
            ++historyCount;
            history.setItem('count', historyCount);
            to.path !== '/' && history.setItem(to.path, historyCount);
            store.commit(actions.UPDATE_DIRECTION, { direction: 'forward' })
        }
        NProgress.start();
        let Href = '';

        //易车生活
        let easycar = {}
        if (to.query.source) {
            easycar.source = to.query.source
        }
        if (to.query.orderNo) {
            easycar.orderNo = to.query.orderNo
        }
        if (to.query.cellPhone) {
            easycar.cellPhone = to.query.cellPhone
        }
        let localEasyCarOrderNo = localStorage.getItem('easycar') ? JSON.parse(localStorage.getItem('easycar')).orderNo : ''
        if (JSON.stringify(easycar) !== '{}' && localEasyCarOrderNo !== easycar.orderNo) {
            localStorage.setItem('easycar', JSON.stringify(easycar))
        }


        if (to.meta) {
            var vm = new Vue();
            if (vm.isWeixin() || vm.isAliPAY()) {
                let wxInsuranceInfo = localStorage.getItem('wxInsuranceInfo') || null
                if (wxInsuranceInfo) { // 无锡人保单独配置
                    next();
                    return;
                }
                Href = siteUrl + "?redirect=" + to.path;
                if (!vm.getCookie('token') && !vm.getCookie('access_token')) { // 未登录
                    if (to.path != '/' && to.path != '/login' && to.path != '/third-login') {
                        localStorage.setItem("from", to.path);
                    }
                    if (to.path.includes('wxInsurance')) { // 无锡人保单独配置
                        next();
                        return;
                    }
                    if (to.path.includes('third-rights')) {
                        next({ path: '/third-login' });
                        return;
                    }
                    const logoutInfo = localStorage.getItem('logoutInfo') ? JSON.parse(localStorage.getItem('logoutInfo')) : null
                    let nowTime = ''
                    let isLogout = false
                    if (logoutInfo) {
                        nowTime = new Date().getTime()
                        isLogout = (nowTime - logoutInfo.time) < 60 * 1000
                    }
                    if (!isLogout) {
                        location.href = Href;
                        return;
                    } else {
                        next()
                    }
                } else if (vm.getCookie('token') || vm.getCookie('access_token')) { // 已登陆
                    // 只有 access_token 时，限制可访问路由为 /、/login、/third-login
                    if (!vm.getCookie('token') && vm.getCookie('access_token')) {
                        const limitedPaths = ['/', '/login', '/third-login'];
                        if (!limitedPaths.includes(to.path)) {
                            store.commit(actions.ROUTER_HISTORY, to.fullPath);
                            if (partner_id && partner_id == LHCXPARTNER_ID) {
                                next({ path: '/third-login' });
                            } else {
                                next({ path: '/login' });
                            }
                            return;
                        }
                    }
                    if (to.meta.requireCity && !localStorage.getItem("cityOption")) {//判断是否需要城市
                        localStorage.setItem("from", to.path);
                        store.commit(actions.ROUTER_HISTORY, to.fullPath);
                        vm.getLocation()
                        next();
                    } else if (to.meta.requireCar && !localStorage.getItem("carInfo") && !vm.getCookie("base_id")) {//判断是否需要车辆
                        localStorage.setItem("from", to.path);
                        store.commit(actions.ROUTER_HISTORY, to.fullPath);
                        next();
                    } else {
                        next();
                    }
                }
                // if (!vm.getCookie('token') && !vm.getCookie('access_token')) {
                //     if(to.path.includes('wxInsurance')){ // 无锡人保单独配置
                //         next();
                //         return;
                //     }
                //     if(to.path.includes('third-rights')){
                //         next({ path: '/third-login' });
                //         return;
                //     }
                //     if (to.path != '/' && to.path != '/login') {
                //         localStorage.setItem("from", to.path);
                //     }
                //     location.href = Href;
                //     return;
                // } else if (vm.getCookie('token') || vm.getCookie('access_token')) {
                //      if (vm.getCookie('access_token') && to.path != '/login' && to.path != '/') {
                //         store.commit(actions.ROUTER_HISTORY, to.fullPath);
                //         if(partner_id && partner_id == LHCXPARTNER_ID){
                //             next({ path: '/third-login' });
                //         } else {
                //             next({ path: '/login' });
                //         }
                //     } else if (to.meta.requireCity && !localStorage.getItem("cityOption")) {//判断是否需要城市
                //         localStorage.setItem("from", to.path);
                //         store.commit(actions.ROUTER_HISTORY, to.fullPath);
                //         next({ path: '/index' });
                //     } else if (to.meta.requireCar && !localStorage.getItem("carInfo") && !vm.getCookie("base_id")) {//判断是否需要车辆
                //         localStorage.setItem("from", to.path);
                //         store.commit(actions.ROUTER_HISTORY, to.fullPath);
                //         next({ path: '/my_cars' })
                //     } else {
                //         next();
                //     }
                // }
            } else {
                if (to.meta.requireAuth && !vm.getCookie('token')) {
                    (to.path != '/' && to.path != '/login') && localStorage.setItem("from", to.path);
                    store.commit(actions.ROUTER_HISTORY, to.fullPath);
                    if (partner_id && partner_id == LHCXPARTNER_ID) {
                        next({ path: '/third-login' });
                    } else {
                        next({ path: '/login' });
                    }
                } else if (to.meta.requireCity && !localStorage.getItem("cityOption")) {//判断是否需要城市
                    store.commit(actions.ROUTER_HISTORY, to.fullPath);
                    vm.getLocation()
                    next();
                } else if (to.meta.requireCar && !localStorage.getItem("carInfo") && !vm.getCookie("base_id")) {//判断是否需要车辆
                    store.commit(actions.ROUTER_HISTORY, to.fullPath);
                    if (!!vm.getCookie('token')) {
                        next();
                    } else {
                        next({ path: '/autobrands' })
                    }
                } else {
                    next();
                }
            }
            vm = null;
        }
    }
})

router.afterEach(transition => {
    NProgress.done();
});

//去除空格
Vue.filter('intTrim', function (value) {
    return $.trim(value);
});

//价格过滤器
Vue.filter('intPart', function (value) {
    value = '' + value;
    return value.split('.')[0];
});

Vue.filter('hideTelphone', function (value) {
    let flag = (/^1[3456789]\d{9}$/.test(value));
    if (flag) {
        return value.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")
    } else {
        return value;
    }
});
Vue.filter('floatPart', function (value) {
    value = '' + value;
    return value.split('.')[1] || '0';
});

Vue.filter('price', function (value) {
    if (!value) {
        value = 0;
    }
    return new Number('' + value).toFixed(1);
});


Vue.filter('unescape', function (html) {
    return html
        .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, "\"")
        .replace(/&#39;/g, "\'");
});

Array.prototype.contains = function (val) {
    var i = this.length;
    while (i--) {
        if (this[i] == val) {
            return true;
        }
    }
    return false;
};
Array.prototype.indexOf = function (val) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] == val) return i;
    }
    return -1;
};
Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};

Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    return moment(value * 1000).format(formatString);
});

//排量整数保留一个小数点
Vue.filter('enginerFixed1', function (value) {
    if (value.indexOf(".") > -1) {
        return value;
    } else {
        let numberVal = value.match(/^\d+/gi) + ".0";
        let stringVal = !!value.match(/[a-z|A-Z]+$/gi) && value.match(/[a-z|A-Z]+$/gi) || '';
        return numberVal + "" + stringVal;
    }

});
Vue.filter('momentYMD', function (value) {
    return moment(value).format('YYYY-MM-DD');
});
Vue.mixin({
    data() {
        return {
            displayCarName: '请选择车辆'
        }
    },
    mounted() {
        const carInfos = localStorage.getItem('carInfo') && JSON.parse(localStorage.getItem('carInfo'))
        const chooseCarList = carInfos && carInfos.chooseCarList && carInfos.chooseCarList.length && JSON.parse(carInfos.chooseCarList) || []
        if (!chooseCarList.length) {
            if (carInfos) {
                this.displayCarName = carInfos.fullname
            }
        } else if (carInfos) {
            // 车系+排量+年份
            this.displayCarName = `${carInfos.model.name}  ${carInfos.engine_displacement} ${carInfos.product_years}`
        }
    },
})
const inBrowser = typeof window !== 'undefined'
let dateObj = new Date()
const DEFAULT_OPTION = {
    locale: 'zh', //en
    color: ' #f29543',
    className: 'selected-day'
}
let Calendar = {
    $vm: null,
    bindEventBus(vm) {
        this.$vm = vm
    },
    toDate(dateString) {
        if (dateString === 'all') {
            this.$vm.CALENDAR_EVENTS_DATA.params = {
                curYear: dateObj.getFullYear(),
                curMonth: dateObj.getMonth(),
                curDate: dateObj.getDate(),
                curEventsDate: 'all'
            }
        } else {
            let dateArr = dateString.split('/')
            dateArr = dateArr.map((item) => {
                return parseInt(item, 10)
            })
            this.$vm.CALENDAR_EVENTS_DATA.params = {
                curYear: dateArr[0],
                curMonth: dateArr[1] - 1,
                curDate: dateArr[2],
                curEventsDate: dateString
            }
        }
    },
    nextMonth() {
        if (this.$vm.CALENDAR_EVENTS_DATA.params.curMonth < 11) {
            this.$vm.CALENDAR_EVENTS_DATA.params.curMonth++
        } else {
            this.$vm.CALENDAR_EVENTS_DATA.params.curYear++
            this.$vm.CALENDAR_EVENTS_DATA.params.curMonth = 0
        }
    },
    preMonth() {
        if (this.$vm.CALENDAR_EVENTS_DATA.params.curMonth > 0) {
            this.$vm.CALENDAR_EVENTS_DATA.params.curMonth--
        } else {
            this.$vm.CALENDAR_EVENTS_DATA.params.curYear--
            this.$vm.CALENDAR_EVENTS_DATA.params.curMonth = 11
        }
    }
}
const calendarOptions = Object.assign(DEFAULT_OPTION, {});
let DataList = [
    {
        options: calendarOptions,
        params: {
            curYear: dateObj.getFullYear(),
            curMonth: dateObj.getMonth(),
            curDate: dateObj.getDate(),
            curEventsDate: 'all'
        }
    },
    {
        options: calendarOptions,
        params: {
            curYear: null,
            curMonth: null,
            curDate: null,
            curEventsDate: 'all'
        }
    }
];
if (dateObj.getMonth() < 11) {
    DataList[1].params.curYear = dateObj.getFullYear();
    DataList[1].params.curMonth = dateObj.getMonth() + 1;
    DataList[1].params.curDate = dateObj.getDate();
} else {
    DataList[1].params.curYear = dateObj.getFullYear() + 1;
    DataList[1].params.curMonth = 0;
    DataList[1].params.curDate = dateObj.getDate();
}
const VueCalendarBarEventBus = new Vue({
    data: {
        CALENDAR_EVENTS_DATA: DataList
    }
})
if (inBrowser) {
    window.VueCalendarBarEventBus = VueCalendarBarEventBus
    Calendar.bindEventBus(VueCalendarBarEventBus)
}
Vue.prototype.$EventCalendar = Calendar;
Vue.prototype.$addStorageEvent = function (type, key, newVal) {
    if (type === 1) {
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                localStorage.setItem(k, val);
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
                // 派发对象
                window.dispatchEvent(newStorageEvent);
            }
        }
        return storage.setItem(key, newVal);
    }
}

import tool from "../src/common/js/tools.js";
Vue.use(tool);

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js